<template>
  <div>
    <div v-show="visible_doc" class="docTable">
      <a-drawer
        :title="previewFileName"
        placement="left"
        width="80%"
        @close="onClose"
        :visible="isPreviewVisible"
      >
        <a-spin :spinning="spinningPreview">
          <canvas
            v-if="docPdf === true"
            id="the-canvas"
            style="direction: ltr; width: 100%"
          />
          <img v-else :src="`${docPdf}`" style="width: 100%" />
          <div style="display: flex; justify-content: space-between">
            <a-button
              :disabled="currentPage - 1 < 1 ? true : false"
              @click="
                currentPage--;
                preview({ file: fileSave, page: currentPage });
              "
            >
              <a-icon type="left" />
              {{ $t("Prev") }}
            </a-button>
            <span>{{ currentPage }} / {{ countPages }}</span>
            <a-button
              :disabled="currentPage + 1 > countPages ? true : false"
              @click="
                () => {
                  currentPage++;
                  preview({ file: fileSave, page: currentPage });
                }
              "
            >
              {{ $t("Next") }}
              <a-icon type="right" />
            </a-button>
          </div>
        </a-spin>
      </a-drawer>
      <div class="documentSearch">
        <div class="functionalRow">
          <a-upload
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            :multiple="true"
            style="margin-right: 15px"
          >
            <a-button
              :disabled="rightEdit == 0"
              type="primary"
              icon="upload"
              :loading="uploading"
              style="width: 100%; margin-left: 15xp"
              >{{ uploading ? $t("Uploading") : $t("Add new") }}</a-button
            >
          </a-upload>
          <a-row type="flex" class="search-wrapper">
            <a-col style="flex: 1; margin-right: 15px">
              <a-dropdown :trigger="['click']">
                <a-input-search
                  class="ant-dropdown-link"
                  @search="handleSearch"
                  :placeholder="$t('Search by name')"
                >
                  <template slot="suffix">
                    <a-tooltip :title="$t('Search by title, name, tag')">
                      <a-icon
                        type="info-circle"
                        style="color: rgba(0, 0, 0, 0.45); margin-right: 5px"
                      />
                    </a-tooltip>
                  </template>
                </a-input-search>
                <a-menu slot="overlay" style="background-color: #fafafa">
                  <a-form
                    :form="form"
                    id="my_form_search_styl"
                    layout="vertical"
                    style="padding: 0 50px"
                  >
                    <a-menu-item key="2">
                      <a-form-item :label="$t('Status')">
                        <a-select
                          mode="multiple"
                          v-decorator="[
                            'status',
                            { rules: [{ required: false }], initialValue: [] },
                          ]"
                        >
                          <a-select-option value="NOWY">{{
                            $t("NOWY")
                          }}</a-select-option>
                          <a-select-option value="DO OPISANIA">{{
                            $t("DO OPISANIA")
                          }}</a-select-option>
                          <a-select-option value="OPISANY">{{
                            $t("OPISANY")
                          }}</a-select-option>
                          <a-select-option value="ZARCHIWIZOWANY">{{
                            $t("ZARCHIWIZOWANY")
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('Keywords')">
                        <a-select
                          mode="multiple"
                          v-decorator="[
                            'tags',
                            { rules: [{ required: false }], initialValue: [] },
                          ]"
                        >
                          <a-select-option v-for="i in key_words" :key="i">{{
                            i
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('Specialization')">
                        <a-select
                          mode="multiple"
                          v-decorator="[
                            'SPECJALIZACJA',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="i in specialization"
                            :key="i"
                            >{{ i }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="3">
                      <a-form-item :label="$t('Document type')">
                        <a-select
                          showSearch
                          optionFilterProp="children"
                          v-decorator="[
                            'document_type',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option value="Dokument zwykly">{{
                            $t("Regular document")
                          }}</a-select-option>
                          <a-select-option value="Dokument poufny">{{
                            $t("Сonfidential document")
                          }}</a-select-option>
                          <a-select-option value="FVZ">{{
                            $t("Invoice")
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="4">
                      <a-form-item :label="$t('Contractor') + ' / HUB'">
                        <a-input
                          @click="handleChangeContractor()"
                          v-model="contractorTitle"
                        />
                        <!-- <a-select
                          showSearch
                          optionFilterProp="children"
                          v-decorator="[
                            'kontragent',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="comp in InitInfo.company"
                            :key="comp.ID"
                            >{{ comp.TITLE }} /
                            {{ comp.UF_CRM_1579190093741 }} }}</a-select-option
                          >
                        </a-select>-->
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="5">
                      <a-form-item :label="$t('File creation date')">
                        <a-range-picker
                          v-decorator="[
                            'CREATE_TIME',
                            {
                              rules: [{ type: 'array', required: false }],
                              initialValue: [],
                            },
                          ]"
                        />
                      </a-form-item>
                      <a-form-item :label="$t('Date of issue')">
                        <a-range-picker
                          v-decorator="[
                            'date_send',
                            {
                              rules: [{ type: 'array', required: false }],
                              initialValue: [],
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-menu-item>

                    <a-menu-item key="6">
                      <a-form-item
                        style="text-align: center"
                        :label-col="{ span: 0 }"
                        :wrapper-col="{ span: 24 }"
                      >
                        <a-button type="primary" @click="handleSearch()">{{
                          $t("Search")
                        }}</a-button>
                        <a-button
                          @click="handleReset()"
                          style="margin-left: 50px"
                          >{{ $t("Reset") }}</a-button
                        >
                      </a-form-item>
                    </a-menu-item>
                  </a-form>
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-col style="margin-right: 15px">
              <a-button
                style="width: 100%; margin-left: 15xp"
                type="primary"
                :icon="iconCheck"
                @click="
                  !iconCheck ? handleSearch(['ZARCHIWIZOWANY']) : handleReset()
                "
                >{{ $t("ZARCHIWIZOWANY") }}</a-button
              >
            </a-col>
            <a-col style="margin-right: 15px">
              <a-button
                :disabled="!hasSelected"
                @click="startExcelTableCheck"
                shape="circle"
                icon="file-excel"
              />
            </a-col>
            <a-col>
              <a-button @click="showModal" shape="circle" icon="setting" />
            </a-col>
          </a-row>
        </div>
      </div>

      <a-modal
        v-model="visibleModal"
        :title="$t('Visible table columns')"
        @ok="handleOkModal"
        :cancelText="$t('Сancel')"
        :okText="$t('oktext')"
      >
        <div>
          <!-- <div :style="{ borderBottom: '1px solid #E9E9E9' }">
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAllInModal"
              @change="onCheckAllChange"
            >{{$t("Mark all fields")}}</a-checkbox>
          </div>
          <br />-->

          <a-checkbox-group
            v-model="checkedList"
            :options="plainOptions"
            :default-value="InitInfo.fields_table"
            @change="onChangeInModalWindow"
          />
        </div>
      </a-modal>

      <div class="documentTable">
        <a-table
          :columns="
            (colums = tableColumns.filter((item) => {
              if (this.InitInfo.fields_table != undefined) {
                if (this.InitInfo.fields_table.indexOf(item.key) != -1)
                  return item;
              }
            }))
          "
          :dataSource="fileList"
          :row-key="(record) => record.mainid"
          :pagination="pagination"
          size="middle"
          tableLayout="auto"
          :scroll="{ x: true }"
          bordered
          @change="onChangeTable"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :locale="{
            emptyText: $t('no data'),
          }"
        >
          <template
            slot="name"
            slot-scope="text, record"
            style="text-align: left"
          >
            <a-button
              @click="goSteps(record)"
              type="link"
              style="text-align: left"
              >{{ text }}</a-button
            >
          </template>

          <template
            slot="status"
            style="display: flex; justify-content: center"
          />

          <template slot="time_change" slot-scope="text">{{
            text != undefined ? text : ""
          }}</template>
          <template slot="actions" slot-scope="text, record">
            <!-- <a-button @click="previewFile(record)" type="link">{{ $t('Preview') }}</a-button> -->

            <div style="display: flex; justify-content: center">
              <a-tooltip placement="top">
                <template slot="title">{{ $t("Download") }}</template>
                <a-icon
                  type="download"
                  @click="downloadFile(record)"
                  class="iconBtn iconBtnSearch"
                />
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">{{ $t("Preview") }}</template>
                <a-icon
                  @click="previewFile(record)"
                  type="search"
                  class="iconBtn iconBtnSearch"
                />
              </a-tooltip>

              <a-popconfirm
                :title="$t('file_delete_confirm')"
                v-show="record.status != 'ZARCHIWIZOWANY'"
                :ok-text="$t('Yes')"
                :cancel-text="$t('No')"
                @confirm="onDeleteFile(record)"
              >
                <!-- <a-button type="link">{{ $t('Delete') }}</a-button> -->
                <a-tooltip placement="top">
                  <template slot="title">{{ $t("Delete") }}</template>
                  <a-icon type="delete" class="iconBtn iconBtnDelete" />
                </a-tooltip>
              </a-popconfirm>
            </div>
          </template>
        </a-table>
        <div>
          <!-- <a-col :span="24">
            <span style="margin-left: 8px">
              <template v-if="hasSelected">{{
                `Selected ${selectedRowKeys.length} items`
              }}</template>
            </span>
          </a-col> -->
        </div>
      </div>
    </div>
    <steps
      v-if="!visible_doc"
      :element="document_record"
      :profile="profile"
      :form_info="InitInfo"
      :responsible="responsible"
      :disableFromResponsible="disableFromResponsible"
      :current="current"
      :specialization="specialization"
      :user_setup="user_setup"
      @back="onback"
      @preview="onpreview"
      :key_words="key_words"
    />
  </div>
</template>
<script>
import steps from "./steps.vue";
import moment from "moment";
import {
  Sort,
  getDocumentAllStage,
  getFilter,
  uploadFile,
  getPoglad,
  deleteFile,
  saveTableSize,
  exportToExcel,
  selectVisibleTableColumns,
} from "../requestFunc";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
// const defaultCheckedList = [...plainOptions];

export default {
  components: {
    steps,
  },
  props: [
    "fileList",
    "InitInfo",
    "key_words",
    "specialization",
    "responsible",
    "user_setup",
  ],
  data() {
    const tableColumns = [
      {
        title: "ID",
        dataIndex: "ID",
        key: "ID",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.ID != undefined ? a.ID : "";
          let bb = b.ID != undefined ? b.ID : "";
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        align: "center",
      },
      {
        title: this.$t("Document name"),
        dataIndex: "title",
        key: "title",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.title != undefined ? a.title : "";
          let bb = b.title != undefined ? b.title : "";
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        align: "center",
        customRender: (text, record) => {
          if (record.title != undefined) {
            return text;
          } else {
            return "";
          }
        },
      },
      // {
      //   title: this.$t("MPK"),
      //   dataIndex: "mpk",
      //   key: "mpk",
      //   sorter: true,
      //   customRender: (text, record) => {
      //     if (record.mpk != undefined) {
      //       return text;
      //     } else {
      //       return "";
      //     }
      //   }
      // },
      {
        title: this.$t("File name"),
        key: "NAME",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.NAME != undefined ? a.NAME : "";
          let bb = b.NAME != undefined ? b.NAME : "";
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        dataIndex: "NAME",
        align: "center",
        scopedSlots: { customRender: "name" },
      },
      {
        title: this.$t("Date of change"),
        key: "time_change",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.time_change != undefined ? a.time_change.length : 0;
          let bb = b.time_change != undefined ? b.time_change.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        dataIndex: "time_change",
        align: "center",
        scopedSlots: { customRender: "time_change" },
      },
      {
        title: this.$t("Date of issue"),
        key: "date_recept",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.date_recept != undefined ? a.date_recept.length : 0;
          let bb = b.date_recept != undefined ? b.date_recept.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        align: "center",
        dataIndex: "date_recept",
      },
      {
        title: this.$t("Tag"),
        key: "Teczka",
        dataIndex: "Teczka",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.Teczka != undefined ? a.Teczka.length : 0;
          let bb = b.Teczka != undefined ? b.Teczka.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        align: "center",
        customRender: (text) => {
          var mas = [];
          if (text != undefined && text != "" && text != "[]") {
            for (let itm of JSON.parse(text)) {
              mas.push(<a-tag color="blue">{itm["tagData"]}</a-tag>);
            }
          }
          return mas;
        },
      },
      {
        title: this.$t("Specialization"),
        key: "SPECJALIZACJA",
        dataIndex: "SPECJALIZACJA",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.SPECJALIZACJA != undefined ? a.SPECJALIZACJA.length : 0;
          let bb = b.SPECJALIZACJA != undefined ? b.SPECJALIZACJA.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],

        align: "center",
        customRender: (text) => {
          try {
            var res = [];
            if (text != undefined && text != "" && text != "[]") {
              try {
                text = JSON.parse(text);
                if (typeof text == "string") throw Error;
              } catch {
                text = [text];
              }
              for (let el of text) {
                res.push(<a-tag color="red">{el}</a-tag>);
              }
            }
            return res;
          } catch {
            return [];
          }
        },
      },
      {
        title: this.$t("Keywords"),
        key: "key_words",
        dataIndex: "key_words",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.key_words != undefined ? a.key_words.length : 0;
          let bb = b.key_words != undefined ? b.key_words.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],

        align: "center",
        customRender: (text) => {
          var mas = [];
          if (text != undefined && text != "" && text != "[]") {
            for (let itm of JSON.parse(text)) {
              mas.push(<a-tag color="green">{itm}</a-tag>);
            }
          }
          return mas;
        },
      },
      {
        title: this.$t("Status"),
        key: "status",
        dataIndex: "status",
        align: "center",
        // sorter: true,
        sorter: (a, b) => {
          let aa = a.status != undefined ? a.status.length : 0;
          let bb = b.status != undefined ? b.status.length : 0;
          // return aa - bb;
          if (aa > bb) return 1;
          if (aa == bb) return 0;
          if (aa < bb) return -1;
        },
        sortDirections: ["descend", "ascend"],
        fixed: "right",
        width: 100,
        customRender: (text) => {
          if (text == null || text == "NOWY") {
            return <a-tag color="#029C8E">{this.$t("NOWY")}</a-tag>;
          }
          if (text == "DO OPISANIA")
            return <a-tag color="#FCB76F">{this.$t("DO OPISANIA")}</a-tag>;
          if (text == "OPISANY")
            return <a-tag color="#E88666">{this.$t("OPISANY")}</a-tag>;
          if (text == "ZARCHIWIZOWANY")
            return <a-tag color="#EA5F40">{this.$t("ZARCHIWIZOWANY")}</a-tag>;
          return this.$t(text);
        },
      },
      {
        title: this.$t("Preview"),
        key: "preview",
        align: "center",
        dataIndex: "DOWNLOAD_URL",
        fixed: "right",
        width: 100,
        scopedSlots: { customRender: "actions" },
      },
    ];
    const plainOptions = [
      { label: "ID", value: "ID" },
      { label: this.$t("Document name"), value: "title" },
      { label: this.$t("File name"), value: "NAME" },
      { label: this.$t("Date of change"), value: "time_change" },
      { label: this.$t("Date of issue"), value: "date_recept" },
      { label: this.$t("Tag"), value: "Teczka" },
      { label: this.$t("Specialization"), value: "SPECJALIZACJA" },
      { label: this.$t("Keywords"), value: "key_words" },
      { label: this.$t("Status"), value: "status" },
      { label: this.$t("Preview"), value: "preview" },
    ];
    return {
      checkedList: this.InitInfo.fields_table,
      pagination: {
        pageSize: this.InitInfo.table_size,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
      },
      indeterminate: true,
      checkAllInModal: false,
      plainOptions,
      visibleModal: false,
      selectedRowKeys: [],
      loading: false,
      countPages: 1,
      currentPage: 1,
      fileSave: "",
      contractor: "",
      contractorTitle: "",
      isPreviewVisible: false,
      spinningPreview: true,
      previewFileName: "",
      addFileList: [],
      iconCheck: undefined,
      uploading: false,
      sortedInfo: { sort_column: undefined, sort_order: undefined },
      filterInfo: undefined,
      profile: [],
      part_max: 0,
      docPdf: null,
      visible_doc: true,
      document_record: null,
      current: 0,
      rightEdit: 0,
      disableFromResponsible: false,
      form: this.$form.createForm(this, { name: "search" }),
      tableSizes: ["10", "20", "50", "100"],
      currentTableSize: this.InitInfo.table_size,
      tableColumns,
      columns: tableColumns,
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    moment,
    downloadFile(record) {
      BX24.callMethod(
        "disk.file.get",
        {
          id: record.ID,
        },
        function (result) {
          if (result.error()) console.error(result.error());
          else {
            const response = result.data();
            var link = document.createElement("a");
            link.setAttribute("href", response.DOWNLOAD_URL);
            link.setAttribute("download", response.NAME);
            onload = link.click();
          }
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contractorTitle = info.company[0].title;
        }
      );
    },
    onChangeTable(pagination, filters, sorter) {
      console.log("params", pagination, filters, sorter);
    },
    showFilteredTable(fileList) {
      return fileList.filter((item) => {
        if (this.InitInfo.fields_table.indexOf(item.key) != -1) return item;
      });
    },
    onChangeInModalWindow(checkedList) {
      // this.checkedList = checkedList;
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAllInModal = checkedList.length === this.plainOptions.length;
    },
    onCheckAllChange(e) {
      // Object.assign(this, {
      this.checkedList = e.target.checked ? this.plainOptions : [];
      this.indeterminate = false;
      this.checkAllInModal = e.target.checked;
      // });
    },
    showModal() {
      this.visibleModal = true;
    },
    handleOkModal() {
      let values = this.checkedList;
      this.changeSpinning();
      selectVisibleTableColumns(values)
        .done((res) => {
          console.log(res);
          this.columns = this.tableColumns.filter((item) => {
            if (this.checkedList.indexOf(item.key) != -1) return item;
          });
          this.InitInfo.fields_table = values;
          this.$message.success(
            this.$t("Saving visibility table columns to  has been completed!")
          );
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.changeSpinning();
        });
      this.visibleModal = false;
    },
    startExcelTableCheck() {
      this.loading = true;
      let values = this.selectedRowKeys;
      this.changeSpinning();
      exportToExcel(values)
        .done((req, r) => {
          let res = JSON.parse(req);
          console.log("getExcel", res, req, r);
          var link = document.createElement("a");
          link.setAttribute("href", res.link);
          link.setAttribute("download", "download");
          onload = link.click();
          this.$message.success(this.$t("Export to excel has been completed!"));
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.loading = false;
          this.changeSpinning();
        });
      this.selectedRowKeys = [];
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      console.log("length:", this.selectedRowKeys.length);
    },
    onClose() {
      this.isPreviewVisible = false;
      this.fileSave = undefined;
    },
    onDeleteFile(file) {
      this.changeSpinning();
      deleteFile(file.mainid, file.ID)
        .done((res) => {
          if (res == "success") {
            this.$emit("filterDocList", file.ID);
            // this.fileList = this.fileList.filter((el) => {
            //   if (el.ID != file.ID) {
            //     return el;
            //   }
            // });
            console.log("length:", this.selectedRowKeys.length);
            this.$message.success(this.$t("file_deletion_succeed"));
          } else if (res == "error") {
            this.$message.error(this.$t("file_deletion_error"));
          }
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    previewFile(file, page) {
      getPoglad(file.ID).done((x) => {
        let file = JSON.parse(x);
        this.currentPage = page || 1;
        this.fileSave = file;
        // this.preview(file);
        this.preview({ file: file, page: this.currentPage });
      });
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    preview({ file, page }) {
      let pdfAsArray = this.Uint8ArrayFromBase64(file.base64file);
      if (file.NAME.indexOf(".jpg") != -1 || file.NAME.indexOf(".png") != -1) {
        this.docPdf = file.DOWNLOAD_URL || file.url;
        this.spinningPreview = false;
      } else {
        this.docPdf = true;
        if (page) this.currentPage = page;
        this.spinningPreview = true;
        // var url = file.DOWNLOAD_URL || file.url;
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        var loadingTask = pdfjsLib.getDocument(pdfAsArray);
        // var loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(
          (pdf) => {
            try {
              this.countPages = pdf.numPages;
              if (1 <= this.currentPage && this.countPages >= this.currentPage)
                pdf.getPage(this.currentPage).then((page) => {
                  var canvas = document.getElementById("the-canvas");
                  let realW = $("#the-canvas").width();
                  var viewport = page.getViewport({
                    scale: realW / page.getViewport({ scale: 1.0 }).width,
                  });
                  var context = canvas.getContext("2d");
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;
                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                  };
                  var renderTask = page.render(renderContext);
                  renderTask.promise
                    .then(() => {
                      $("#the-canvas").css("border", "1px solid");
                      this.spinningPreview = false;
                      this.resize();
                      return page.getTextContent();
                    })
                    .then(function (textContent) {
                      var pdf_canvas = $("#the-canvas");
                      var canvas_height = pdf_canvas.get(0).height;
                      var canvas_width = pdf_canvas.get(0).width;
                      $("#text-layer-table").css({
                        // left: canvas_offset.left + "px",
                        // top: canvas_offset.top + "px",
                        left: "2px",
                        top: "2px",
                        height: canvas_height + "px",
                        width: canvas_width + "px",
                      });
                      pdfjsLib.renderTextLayer({
                        textContent: textContent,
                        container: $("#text-layer-table").get(0),
                        viewport,
                        textDivs: [],
                      });
                    });
                });
            } catch {
              this.spinningPreview = false;
            }
          },
          (reason) => {
            this.spinningPreview = false;
            console.error(reason);
          }
        );
      }
      this.previewFileName = file.NAME;
      this.isPreviewVisible = true;
      // if (doc.NAME.indexOf(".jpg") != -1 || doc.NAME.indexOf(".png") != -1) {
      //   this.docPdf = doc.DOWNLOAD_URL;
      //   this.spinningPreview = false;
      // } else {
      //   this.docPdf = true;
      //   this.spinningPreview = true;
      //   var url = doc.DOWNLOAD_URL;
      //   var pdfjsLib = window["pdfjs-dist/build/pdf"];
      //   pdfjsLib.GlobalWorkerOptions.workerSrc =
      //     "//mozilla.github.io/pdf.js/build/pdf.worker.js";
      //   var loadingTask = pdfjsLib.getDocument(url);

      //   loadingTask.promise.then(
      //     (pdf) => {
      //       try {
      //         this.countPages = pdf.numPages;
      //         if (1 <= this.currentPage && this.countPages >= this.currentPage)
      //           pdf.getPage(this.currentPage).then((page) => {
      //             var scale = 2.0;
      //             var viewport = page.getViewport({ scale: scale });
      //             var canvas = document.getElementById("the-canvas");
      //             var context = canvas.getContext("2d");
      //             canvas.height = viewport.height;
      //             canvas.width = viewport.width;
      //             var renderContext = {
      //               canvasContext: context,
      //               viewport: viewport,
      //             };
      //             var renderTask = page.render(renderContext);
      //             renderTask.promise.then(() => {
      //               // eslint-disable-next-line
      //               $("#the-canvas").css("border", "1px solid");
      //               this.spinningPreview = false;
      //               // eslint-disable-next-line
      //               BX24.fitWindow();
      //             });
      //           });
      //       } catch {
      //         this.spinningPreview = false;
      //       }
      //     },
      //     (reason) => {
      //       this.spinningPreview = false;
      //       console.error(reason);
      //     }
      //   );
      // }
      // this.previewFileName = doc.NAME;
      // this.isPreviewVisible = true;
    },
    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "addfile");
      formData.append("folder", this.InitInfo.user_folder);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          this.addFileList = [];
          this.uploading = false;
          if (res["result"] == "success") {
            this.fileList.unshift(res["file"]);
            this.$message.success(this.$t("Upload successful") + ".");
          } else {
            this.$message.error(this.$t("Upload failed") + ".");
            this.$message.error(
              this.$t("Select a storage location from Bitrix24.Drive folders") +
                "."
            );
          }
        })
        .fail((e) => {
          this.uploading = false;
          console.error(e);
          this.$message.error(this.$t("Upload failed") + ".");
        });
    },
    handleSearch(input) {
      console.log(input, "input");
      this.form.validateFields((err, values) => {
        if (
          // eslint-disable-next-line
          $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
          // eslint-disable-next-line
          $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
        ) {
          // eslint-disable-next-line
          $(".search-wrapper input").click();
        }

        // indefined, object
        if (typeof input != "undefined") {
          if (Array.isArray(input)) {
            values["status"] = input;
          } else {
            values["title"] = input;
          }
          this.iconCheck = "check";
        } else {
          console.log(values, "values");
          this.iconCheck = undefined;
          values["date_send"] =
            values.date_send.length != 0
              ? [
                  moment(values.date_send[0]).format("YYYY-MM-DD"),
                  moment(values.date_send[1]).format("YYYY-MM-DD"),
                ]
              : undefined;

          values["CREATE_TIME"] =
            values.CREATE_TIME.length != 0
              ? [
                  moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                  moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
                ]
              : undefined;
          values["title"] = input;
          values["NAME"] = values.NAME == "" ? undefined : values.NAME;
          values["mpk"] = values.mpk == "" ? undefined : values.mpk;
          if (this.contractor) values.kontragent = this.contractor;
        }

        this.changeSpinning();

        this.filterInfo = values;

        getFilter(values)
          .done((data) => {
            this.$emit("updateFiles", { files: JSON.parse(data) });
            this.$message.success(this.$t("Filter ok"));
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning();
          });
      });
    },
    handleReset() {
      if (
        // eslint-disable-next-line
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        // eslint-disable-next-line
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        // eslint-disable-next-line
        $(".search-wrapper input").click();
      }
      this.changeSpinning();
      this.form.resetFields();
      this.filterInfo = undefined;
      this.sortedInfo = { sort_column: undefined, sort_order: undefined };
      this.iconCheck = undefined;
      this.contractor = "";
      this.contractorTitle = "";

      getFilter()
        .done((data) => {
          let elem = JSON.parse(data);
          this.$emit("updateFiles", { files: elem });
          this.$message.success("Reset filter ok");
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error loading files"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    handleChange(pagination, filters, sorter) {
      if (
        this.sortedInfo.sort_column != sorter["columnKey"] ||
        this.sortedInfo.sort_order != sorter["order"]
      ) {
        this.changeSpinning();

        if (Object.keys(sorter).length != 0) {
          this.sortedInfo = {
            sort_column: sorter["columnKey"],
            sort_order: sorter["order"],
          };
        } else {
          this.sortedInfo = { sort_column: undefined, sort_order: undefined };
        }

        Sort(0, this.sortedInfo, this.filterInfo)
          .done((data) => {
            let elem = JSON.parse(data);
            this.$emit("updateFiles", { files: elem });
            if (this.sortedInfo.sort_column != undefined) {
              this.$message.success(
                "Sort " +
                  this.sortedInfo.sort_order +
                  " from " +
                  this.sortedInfo.sort_column +
                  ", ok"
              );
            } else {
              this.$message.success("Sort reset ok");
            }
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning();
          });
      }
    },
    handleChangeTableSize(value) {
      var table_size_value = value;
      this.changeSpinning();
      saveTableSize(table_size_value)
        .done((res) => {
          console.log("Приход: " + res);
          this.InitInfo.table_size = table_size_value;
          this.$message.success("Table size have been saved!");
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    onback(data) {
      this.$emit("refresh");
      this.visible_doc = data.visible_doc;
    },
    onpreview(data) {
      this.previewFile(data.file, data.page);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    goSteps(record) {
      this.changeSpinning();

      if (record.status == undefined || record.status == "NOWY") {
        this.current = 0;
      } else if (record.status == "DO OPISANIA") {
        this.current = 1;
      } else {
        this.current = 2;
      }
      this.disableFromResponsible = false;
      let first_stage = this.current == 0 ? true : false;
      let id_file = record.ID;

      getDocumentAllStage(first_stage, id_file)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);
          Object.assign(record, item);
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error loading document"));
        })
        .always(() => {
          // eslint-disable-next-line
          BX24.callMethod("profile", {}, (res) => {
            this.profile = res.data();
            this.visible_doc = !this.visible_doc;
            this.document_record = record;
            if (record.crm_user == undefined || record.crm_user == true) {
              this.disableFromResponsible = false;
            } else if (
              record.crm_user == false &&
              this.responsible.indexOf(res.answer.result.ID + "") != -1 &&
              this.current != 0 &&
              res.answer.result.ADMIN != true
            ) {
              this.current = 0;
              this.disableFromResponsible = true;
            }
            this.changeSpinning();
            // eslint-disable-next-line
            BX24.fitWindow();
          });
        });
    },
    resize() {
      // eslint-disable-next-line
      BX24.resizeWindow(
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "width"
          )
        ),
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "height"
          )
        )
      );
    },
  },
  mounted() {
    // this.columns = this.tableColumns.filter(item => {
    //   if (this.InitInfo.fields_table.indexOf(item.key) != -1) return item;
    // });
    // eslint-disable-next-line
    BX24.init(() => {
      // eslint-disable-next-line
      let isAdm = BX24.isAdmin();
      // eslint-disable-next-line
      BX24.callMethod("user.current", {}, (res) => {
        this.rightEdit =
          isAdm || this.user_setup.responsible.includes(res.data().ID) ? 1 : 0;
      });
    });
    // eslint-disable-next-line
    BX24.fitWindow();
  },
  updated() {
    // if (this.checkedList != undefined)
    //   this.columns = this.showFilteredTable(this.checkedList);
    this.resize();
  },
};
</script>
<style scoped>
.docTable {
  display: flex;
  flex-direction: column;
}

.documentSearch {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 15px;
}

.documentSearch > div {
  margin: 5px 0px;
  width: 100%;
  text-align: left;
  align-self: flex-start;
}

.documentSearch .functionalRow {
  display: flex;
  justify-content: space-around;
  /* justify-content: space-between; */
  margin-bottom: 5px;
}

.documentSearch .functionalRow .documentAdd__btn {
  margin-right: 15px;
  display: flex;
  align-self: center;
}

.documentSearch .functionalRow .search-wrapper {
  width: 100%;
}

.documentTable {
  min-height: 401px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.ant-dropdown-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.table-operations {
  margin-bottom: 16px;
}

.table-operations > div {
  margin-right: 10px;
}

.iconBtn {
  font-size: 20px;
}

.iconBtnSettings {
  font-size: 32px;
}

.iconBtnSettings:hover,
.iconBtnSearch:hover {
  color: #1890ff;
}

.iconBtnDelete:hover {
  color: #f5222d;
}

.ant-pagination {
  background-color: red;
}

.ant-table {
  /* white-space: nowrap; */
  border-collapse: collapse;
  /* border-spacing:0px; */
}
</style>
